// extracted by mini-css-extract-plugin
export default {"container":"kvaym","title":"OeBkI","content":"_dUbY","fadeIn":"QcHhx","center":"nup0t"};